import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useWeb3React } from '@web3-react/core';
import { MdOutlineSwapVerticalCircle } from 'react-icons/md';
import { Stack, HStack, Icon, Text, useColorMode } from '@chakra-ui/react';

import JumpButton from '../../../iZUMi-UI-toolkit/src/components/Buttons/JumpButton/JumpButton';
import CustomButton from '../../../iZUMi-UI-toolkit/src/components/Buttons/CustomButton/CustomButton';

import { i_h3 } from '../../../style';
import { PositionList } from './components/PositionList';
import NotConnectModal from '../components/NotConnectModal';
import { getColorThemeSelector } from '../../../utils/funcs';
import PageHeader from '../../../components/PageHeader/PageHeader';
import PageLayout from '../../../components/layout/PageLayout';
import MyLiquidityControls from './components/MyLiquidityControl';
import ChainNotValidBlockWrapper from '../../components/ChainNotValidBlock';
import NetworkSelect from '../../../components/Select/NetworkSelect/NetworkSelect';
import WalletButton from '../../../components/Buttons/WalletButton/WalletButton';
import { useTranslation } from 'react-i18next';
import useIsMobile from '../../../iZUMi-UI-toolkit/src/hooks/useIsMobile';

const Liquidity: React.FC = () => {
    const { t } = useTranslation();
    const { account } = useWeb3React();
    useEffect(() => {
        document.title = 'Liquidity | Arctic';
    }, []);
    const history = useHistory();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const isMobile = useIsMobile();

    return isMobile ? (
        <PageLayout
            body={
                account ? (
                    <ChainNotValidBlockWrapper
                        content={
                            <Stack w="100%">
                                <MyLiquidityControls />
                                <PositionList />
                            </Stack>
                        }
                        app="trade"
                    />
                ) : (
                    <NotConnectModal />
                )
            }
            type="mobile"
        />
    ) : (
        <PageLayout
            header={
                <PageHeader
                    headerTitle={t('Liquidity')}
                    subtitle={t('Provide liquidity to earn transaction fees') + '.'}
                    element={
                        <HStack spacing="10px">
                            <CustomButton
                                variant="tertiary"
                                w="34px"
                                h="34px"
                                borderRadius="3px"
                                text={<Icon as={MdOutlineSwapVerticalCircle} boxSize="28px" px="3px" />}
                                onClick={() => {
                                    history.push('/trade/swap');
                                }}
                            />

                            <JumpButton
                                disabled={!account}
                                w="140px"
                                h="40px"
                                text={t('Add Liquidity') + ' +'}
                                target="/trade/add-liquidity"
                            />
                            <NetworkSelect />
                        </HStack>
                    }
                />
            }
            body={
                account ? (
                    <ChainNotValidBlockWrapper
                        content={
                            <Stack w="100%">
                                <MyLiquidityControls />
                                <PositionList />
                            </Stack>
                        }
                        app="trade"
                    />
                ) : (
                    <NotConnectModal />
                )
            }
            internalWidth={{ base: '100%', sm: '700px', xl: '840px', xxl: '1100px', xlp1: '1150px' }}
        />
    );
};

export default Liquidity;
